import request from '@/utils/request'
const url = '/admin/attachment/'
const api = {
  Query(data) {
    return request({
      url: url + 'Query',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: url + 'delete',
      method: 'post',
      data
    })
  },
  Update(data) {
    return request({
      url: url + 'update',
      method: 'post',
      data
    })
  },
  Create(data) {
    return request({
      url,
      method: 'post',
      data
    })
  }
}
export default api
